<template>
  <Card class="card-wrapper--thanksAll" :showBtn="false" :btnMsg="$t('thanksAll.btn_text')">
    <div class="card-thanksAll">
      <div class="bg"></div>
      <div class="card-content">
        <div class="done-step-dots" aria-hidden="true"><i>✓</i><b></b><i>✓</i><b></b><i>✓</i></div>
        <div class="done-ring" aria-hidden="true"><svg class="done-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12 L10 18 L20 6" /></svg></div>
        <div class="done-title">{{ $t('thanksAll.doneTitle') }}</div>
        <div class="done-description">{{ $t('thanksAll.doneDescription') }}</div>
        <div class="done-status">
          <div class="done-status-heading"><span>{{ $t('thanksAll.request') }}</span><strong><i></i>{{ $t('thanksAll.processing') }}</strong></div>
          <div class="done-progress"><span></span></div>
          <p>{{ $t('thanksAll.deliveryPrefix') }} <b>{{ $t('thanksAll.deliveryTime') }}</b> {{ $t('thanksAll.deliverySuffix') }}</p>
        </div>
        <div class="done-reward-heading"><strong>{{ $t('thanksAll.rewardTitle') }}</strong><span>{{ $t('thanksAll.rewardDescription') }}</span></div>
        <div class="done-reward-wrap">
          <div class="done-reward reference-gift-card" :class="rewardPalette">
            <img v-if="rewardImage" class="done-reward-image" :src="rewardImage" :alt="rewardName" />
            <div v-else class="reference-card-inner">
              <span class="reference-card-top"><strong class="brand-word">{{ rewardName }}</strong><small>GIFT CARD</small></span>
              <span class="reference-gift-image reference-gift-placeholder">{{ rewardName }}</span>
              <span class="reference-card-bottom"><i></i><small>•••• 2026</small><b>$20</b></span>
            </div>
          </div>
        </div>
        <div class="done-next-steps">
          <div v-for="(item, index) in nextSteps" :key="item"><i>{{ index + 1 }}</i><span>{{ item }}</span></div>
        </div>
        <p class="done-support">{{ $t('thanksAll.supportText') }} <a href="mailto:customerservice8@yeah.net">customerservice8@yeah.net</a></p>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    selectedGift() {
      return this.$parent.selectedGift;
    },
    rewardImage() {
      return this.selectedGift && this.selectedGift.channel_pic || this.form.channel_pic;
    },
    nextSteps() {
      return [this.$t('thanksAll.verifyStep'), this.$t('thanksAll.approvedStep'), this.$t('thanksAll.spamStep')];
    },
    rewardPalette() {
      const name = String(this.selectedGift && this.selectedGift.channel_name || '').trim().toLowerCase();
      const palettes = { paypal: 0, walmart: 1, apple: 2, starbucks: 3 };
      return `reference-gift-palette-${Object.prototype.hasOwnProperty.call(palettes, name) ? palettes[name] : 0}`;
    },
    rewardName() {
      const selected = this.selectedGift;
      if (!selected) return this.$t('苹果卡');
      return this.$i18n.locale === 'zh'
        ? selected.channel_name_zh || selected.channel_name || ''
        : selected.channel_name || selected.channel_name_zh || '';
    },
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    cancel() {
      this.$emit('input', {});
      this.$parent.changeStep('formBasic');
    },
  },
};
</script>

<style lang="scss">
.card-thanksAll {
  --done-heading-size: clamp(20px, 3vw, 24px);
  --done-subtitle-size: 14px;
  position: relative;
  width: 100%;
  min-height: 100%;
  color: #1a2233;
  .card-content { display: flex; width: 100%; max-width: 900px; flex-direction: column; align-items: center; gap: 14px; margin: 0 auto; text-align: center; }
  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('../../assets/thanks-bg1.png');
    opacity: .12;
    pointer-events: none;
  }
  .done-title { font-size: var(--done-heading-size) !important; font-weight: 800; line-height: 1.2; }
  .done-description { max-width: 680px; color: #475569; font-size: var(--done-subtitle-size) !important; line-height: 1.5; }
  .done-status { width: 100%; margin-top: 0; padding: 18px 22px; border: 1px solid rgba(34,197,94,.45); border-radius: 24px; background: linear-gradient(135deg, rgba(34,197,94,.1), rgba(14,165,233,.1)); text-align: left; }
  .done-status-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; color: #475569; font-size: 16px; }
  .done-status-heading > span { color: #16a34a; font-size: 16px; font-weight: 700; }
  .done-status-heading strong { display: inline-flex; align-items: center; gap: 10px; color: #16a34a; font-size: 16px; }
  .done-status-heading i { width: 10px; height: 10px; border-radius: 50%; background: #16a34a; animation: statusPulse 1.6s infinite; }
  .done-progress { height: 8px; margin: 16px 0 12px; overflow: hidden; border-radius: 8px; background: rgba(255,255,255,.8); }
  .done-progress span { display: block; width: 75%; height: 100%; border-radius: inherit; background: linear-gradient(90deg, #16a34a, #0ea5e9); animation: doneProgressFill .9s ease-out both; }
  .done-status p { color: #64748b; font-size: var(--done-subtitle-size); text-align: center; }
  .done-status p b { color: #1a2233; }
  .done-reward-heading { display: flex; flex-direction: column; gap: 4px; margin-top: 0; }
  .done-reward-heading strong { font-size: var(--done-heading-size) !important; }
  .done-reward-heading span { color: #64748b; font-size: var(--done-subtitle-size) !important; }
  .done-next-steps { display: grid; width: 100%; gap: 0; margin-top: 0; overflow: hidden; border: 1px solid rgba(255,255,255,.9); border-radius: 16px; background: rgba(255,255,255,.72); text-align: left; }
  .done-next-steps > div { display: flex; min-height: 54px !important; align-items: center; gap: 12px; padding: 10px 16px !important; border: 0; border-radius: 0; background: transparent; color: #475569; font-size: 14px; line-height: 1.45; }
  .done-next-steps > div + div { border-top: 1px solid rgba(148,163,184,.18); }
  .done-next-steps i { display: grid; width: 30px; height: 30px; flex: 0 0 30px; place-items: center; border-radius: 50%; background: rgba(201,161,39,.14); color: #a47e12; font-size: 13px; font-style: normal; font-weight: 800; }
}
.card-wrapper--thanksAll { width: calc(100% - 48px); max-width: 1080px; max-height: 94%; padding: 34px 44px; }
@keyframes statusPulse { 50% { opacity: .35; transform: scale(.82); } }
@keyframes doneProgressFill { from { width: 0; } to { width: 75%; } }
@media (max-width: 640px) {
  .card-wrapper--thanksAll { width: calc(100% - 24px); padding: 22px 18px; }
  .card-thanksAll .card-content { gap: 12px; }
  .card-thanksAll .done-status { padding: 14px; }
  .card-thanksAll .done-reward-wrap { margin-top: 8px; }
}
</style>
